<template>
  <div>
    <div>
      <el-input
        v-model="query.user_id"
        class="inptw"
        placeholder="请输入主账号id"
      />
      <el-input
        v-model="query.sub_uc_id"
        class="inptw"
        placeholder="请输入子账号"
      />
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
    </div>
    <el-table
      ref="baiduTable"
      :data="baidudatalist"
      row-key="id"
      highlight-current-row
      border
      style="width: 100%;margin-top: 10px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="55"
      />
      <el-table-column
        prop="user_id"
        label="主账号id"
        width="90px"
      />
      <el-table-column
        prop="sub_uc_id"
        label="子账户id"
        width="90px"
      />
      <el-table-column
        prop="sub_uc_name"
        label="子账号名称"
        width="180px"
      />
      <el-table-column
        prop="liceName"
        label="账户主体名称"
        width="180px"
      />
      <el-table-column
        prop="cid"
        label="账户主体id"
        width="150px"
      />
      <el-table-column
        prop="balance"
        label="账户余额"
        width="80px"
      />
      <el-table-column
        prop="budget"
        label="账户预算"
        width="80px"
      />
      <el-table-column
        prop="id"
        label="id"
        width="80px"
      />
      <el-table-column
        prop="userStat"
        label="账户状态"
        width="80px"
      />
      <el-table-column
        prop="created_at"
        label="创建时间"
        width="180px"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-button type="success" @click="$emit('commit',selected,type)">确认</el-button>
    <el-button type="info" @click="$emit('close')">关闭</el-button>
  </div>
</template>

<script>

import PaginationRight from '@/components/PaginationRight/index.vue'
import { getBaiduADAccountList } from '@/api/baiduAD'

export default {
  components: { PaginationRight },
  props: {
    selecteds: {
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: null
    },
    type: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      baidudatalist: [],
      query: {
        page: 1,
        page_size: 10,
        sub_uc_id: null,
        user_id: null
      },
      total: null,
      selected: []
    }
  },
  watch: {
    selecteds(newVal, oldVal) {
      console.log('123123', newVal)
      this.selected = newVal
      this.setSelectedRows(this.selected)
    }
  },
  created() {
    this.list()
  },
  methods: {
    list() {
      getBaiduADAccountList(this.query).then(res => {
        this.baidudatalist = res.data.list
        this.total = res.data.total
      })
    },
    search() {
      this.query.page = 1
      this.list()
    },
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    },
    handleSelectionChange(selectedRows) {
      this.selected = selectedRows
    },
    sendr(val) {
      this.selecteds.splice(0, this.selecteds.length)
      this.selected = val
    },
    setSelectedRows(selectedIds) {
      // 根据传入的 ID 选中对应行
      this.$nextTick(() => {
        selectedIds.forEach(item => {
          const row = this.baidudatalist.find(row => row.id === item.id)
          if (row) {
            this.$refs.baiduTable.toggleRowSelection(row, true) // 选中对应行
          }
        })
      })
    }
  }
}
</script>

<style scoped>
.inptw {
  width: 200px;
  margin-right: 10px;
}
</style>
